import styled, { css } from 'styled-components';

// Shared styles for the data-point mapping rows used by both the Active Directory and the
// LMS API integration mappings. Keeps the connector line and its layout in a single place.

export const dataPointMappingLayoutStyles = css`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;

    .without-label {
        flex: 1 1 0;
    }

    owc-assistive-text[status='warning'] {
        color: var(--one-color-interaction-active-intensity-medium);
    }
`;

export const DataPointMappingOptions = styled.div`
    position: absolute;
    top: 6px;
    right: -50px;
`;

export const DataPointMappingUnion = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 72px;
    height: 1px;

    /* margin-top centers the connector on the 40px field input; v7's baseline sat it low. */
    margin-top: 20px;
    background: #000;

    &::before {
        color: #000;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 4px solid #000;
    }

    &::after {
        color: #000;
        border-top: 4px solid transparent;
        border-right: 4px solid #000;
        border-bottom: 4px solid transparent;
    }

    &::after,
    &::before {
        display: block;
        width: 0;
        height: 0;
        content: '';
    }
`;
